'use strict';

import Vue from 'vue';
import { JsBridge, ActUtils as _ } from '@ie-activity/oversea-act-js-lib'
import * as System from '@src/utils/system';
import * as Types from '@src/store/types';

const state = {
    commerceList: [],
    defaultList: [],
    finalList: []
};

const mutations = {
    /**
     * 设置APP信息
     * */
    [Types.SET_APP_INFO](state, payload) {
        if (!payload.appId) {
            return;
        }

        if (payload.appInfoMap && _.isString(payload.appInfoMap.iconUrl)) {
            let iconUrl = payload.appInfoMap.iconUrl;

            iconUrl = _.addWebpExt(_.clearHttpProtocol(iconUrl), { width: 120 });

            payload.appInfoMap.iconUrl = iconUrl;
        }

        Vue.set(state, payload.appId, {
            ...state[payload.appId],
            ...payload
        });
    },

    /**
     * 插入列表
     * */
    [Types.APPEND_APP_LIST](state, { type = 'default', appIds = [] }) {
        if (!appIds || appIds.length === 0) {
            return;
        }

        if (type === 'default') {
            state.defaultList = [...state.defaultList, ...appIds];
        } else {
            state.commerceList = [...state.commerceList, ...appIds];
        }
    },

    /**
     * 清理列表
     * */
    [Types.CLEAR_APP_LIST](state, type = 'default') {
        if (type === 'default') {
            state.defaultList = [];
        } else {
            state.commerceList = [];
        }
    },

    /**
     * 生成最终的APP列表
     * 1、商业化APP列表 & 兜底APP列表选择
     * 2、资源下沉
     * */
    [Types.SORT_APP_LIST](state) {
        let list;

        // 列表选择
        if (state.commerceList && state.commerceList.length > 0) {
            list = state.commerceList;
        } else {
            list = state.defaultList || [];
        }

        // 资源下沉
        let apps = list.map((id) => {
            return state[id] || {};
        });
        let operateApps = {};
        let vipList = [];
        let normalList = [];
        let sinkList = [];
        let length = apps.length;

        for (let i = 0; i < length; i++) {
            let app = apps[i];
            let appInfoMap = app.appInfoMap || {};

            if (appInfoMap.isVip) {
                vipList.push(app);
            } else if (+app.positionType === 0) {
                operateApps[app.position] = app;
            } else if (_.hasOpenRecord(app.pkgName)) {
                sinkList.push(app);
            } else {
                normalList.push(app);
            }
        }
        apps = [];
        for (let i = vipList.length + 1; i < length + 2; i++) {
            if (operateApps[i]) {
                apps.push(operateApps[i]);
            } else if (normalList.length > 0) {
                apps.push(normalList.shift());
            } else if (sinkList.length > 0) {
                apps.push(sinkList.shift());
            }
        }
        apps = vipList.concat(apps);

        state.finalList = apps.map((app) => {
            return app.appId;
        });
    }
};

let satisfyApps = [];
let filterApps = [];
let target = 50;
let isEnd = false;
let times = 0;
let startNum = 0;

function loadAppList() {
    return _.jsonpFn({
        url: `${System.actDomain}/activity-resource/commerce/v3/query`,
        data: {
            actId: _.getActId(),
            commerce: true,
            index: 0,
            start: startNum,
            limit: 20
        }
    }).then(
        (apps) => {
            isEnd = true;

            return Promise.resolve();
        },
        (apps) => {
            apps = apps || [];

            for (let i = 0; i < apps.length; i++) {
                let app = apps[i];
                if (
                    !app.appInfoMap.isVip &&
                    app.positionType !== 0 &&
                    (_.hasOpenRecord(app.pkgName) || JsBridge.isInstalled(app.pkgName))
                ) {
                    filterApps.push(app);
                } else {
                    satisfyApps.push(app);
                }
            }

            startNum += apps.length;

            if (apps.length < 20) {
                isEnd = true;
            }
            return Promise.resolve();
        }
    );
}

const actions = {
    /**
     * 获取商业化APP列表(不分页)
     * */
    [Types.FETCH_COMMERCE_APP_LIST]({ commit, dispatch }) {
        return loadAppList().then(() => {
            if (satisfyApps.length < target && !isEnd && times < 7) {
                times++;
                return dispatch(Types.FETCH_COMMERCE_APP_LIST);
            } else {
                let apps = satisfyApps.concat(filterApps).splice(0, 50);
                let appIds = [];

                for (let i = 0; i < apps.length; i++) {
                    appIds.push(apps[i].appId);
                    commit(Types.SET_APP_INFO, apps[i]);
                }
                commit(Types.APPEND_APP_LIST, {
                    type: 'commerce',
                    appIds
                });
                commit(Types.SORT_APP_LIST);

                return Promise.resolve();
            }
        });
    }
};

export default {
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js